import { ImgHTMLAttributes } from "react";

interface PictureProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

/**
 * Renders a <picture> with WebP source and original fallback.
 * Assumes WebP files exist alongside originals with .webp extension.
 */
const Picture = ({ src, ...imgProps }: PictureProps) => {
  const webpSrc = src.replace(/\.[^.]+$/, ".webp");

  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img src={src} {...imgProps} />
    </picture>
  );
};

export default Picture;
